import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  oktaAuthApiRef,
} from '@backstage/frontend-plugin-api';
import ScatterPlot from '@material-ui/icons/ScatterPlot';
import { graphEngineDetailsRouteRef, rootRouteRef } from './routes';
import { graphEngineApiRef } from './types';
import { GraphEngineClient } from './api/GraphEngineClient';

// ── API (→ global API registry) ─────────────────────────
const graphEngineApi = ApiBlueprint.make({
  name: 'graph-engine-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: graphEngineApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          oktaAuthApi: oktaAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, oktaAuthApi }) =>
          new GraphEngineClient({ discoveryApi, fetchApi, oktaAuthApi }),
      }),
    ),
});

// ── Routes (→ app/routes) ───────────────────────────────
const listPage = PageBlueprint.make({
  params: {
    title: 'Graph Engines',
    icon: <ScatterPlot fontSize="inherit" />,
    path: '/graph-engines',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/GraphEnginesListPage/GraphEnginesListPage').then(
        m => <m.GraphEnginesListPage />,
      ),
  },
});

const detailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/graph-engines/:graphEngineId',
    routeRef: graphEngineDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/GraphEngineDetailsPage/GraphEngineDetailsPage').then(
        m => <m.GraphEngineDetailsPage />,
      ),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-graph-engine',
  extensions: [graphEngineApi, listPage, detailPage],
  routes: {
    root: rootRouteRef,
    graphEngineDetails: graphEngineDetailsRouteRef,
  },
});
